export default function(_) {
  return _ == null || _ === '' ? null : _ + '';
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/toString.js
// module id = 1595
// module chunks = 0